<template>
  <div>
    <Modal v-model="sourceTableModal" width="800">
      <div v-if="info.origin_tab" style="font-size: 14px">
        <span style="color: #999">共 ({{ info.origin_tab.split(',').length }}) 张源表</span>
        <Divider/>
        <p v-for="(item, index) in info.origin_tab.split(',')" :key="item + '_' + index" style="word-wrap: break-word;">{{ item }}</p>
      </div>
      <div slot="footer">
        <Button @click="sourceTableModal = false">关闭</Button>
      </div>
    </Modal>
    <Modal v-model="resultModal" title="执行报告" width="1000">
      <div style="font-size: 14px" class="db-data-migrate-result">
        <pre>{{ info.result }}</pre>
      </div>
      <div slot="footer">
        <Button @click="resultModal = false">关闭</Button>
      </div>
    </Modal>
    <Modal v-model="refuseModal" title="驳回">
      <div>
        <Input v-model="refuseContent" style="width: 100%" type="textarea" :rows="4" placeholder="驳回原因（选填）" />
      </div>
      <div slot="footer">
        <Button type="error" :loading="refuseSubmitting" @click="refuse">驳回</Button>
        <Button @click="refuseModal = false">取消</Button>
      </div>
    </Modal>
    <Row :style="{marginBottom: '10px'}">
      <div :style="{float: 'left'}">
        <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'dbDataMigrateFlow', query: { page: $route.query.lastPage }})">返回列表</Button>
      </div>
    </Row>
    <Card shadow class="content workflow-module-detail-content">
      <div class="main">
        <div>
          <Row style="margin-bottom: 10px">
            <Col :xs="24" :sm="24" :md="24" :lg="15">
              <Row class="title">
                <h4 :style="{float: 'left'}">工作流详情</h4>
              </Row>
              <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
              <div class="info-property" v-else>
                <dl>
                  <dt>标题</dt><dd>{{ info.title }}</dd>
                </dl>
                <dl>
                  <dt>申请人</dt><dd v-if="info.applicant">{{ info.applicant.name ?
                  info.applicant.name : info.applicant.username }}</dd>
                </dl>
                <dl>
                  <dt>项目</dt><dd>{{ info.tenant_name }}</dd>
                </dl>
                <dl>
                  <dt>源实例</dt><dd>{{ info.origin_instance_name ? info.origin_instance_name : info.origin_instance_id }}</dd>
                </dl>
                <dl>
                  <dt>目标实例</dt><dd>{{ info.target_instance_name ? info.target_instance_name : info.target_instance_id }}</dd>
                </dl>
                <dl>
                  <dt>源库</dt><dd>{{ info.origin_db }}</dd>
                </dl>
                <dl>
                  <dt>目标库</dt><dd>{{ info.target_db }}</dd>
                </dl>
                <dl>
                  <dt>源表</dt><dd><a v-on:click="sourceTableModal = true">查看</a></dd>
                </dl>
                <dl>
                  <dt>新建数据库</dt><dd>{{ info.is_new_db ? '是' : '否' }}</dd>
                </dl>
                <dl>
                  <dt>迁移数据</dt><dd>{{ info.is_export_data ? '是' : '否' }}</dd>
                </dl>
                <dl>
                  <dt>迁移视图</dt><dd>{{ info.is_export_view ? '是' : '否' }}</dd>
                </dl>
                <dl>
                  <dt>迁移存储过程/函数</dt><dd>{{ info.is_export_routine ? '是' : '否' }}</dd>
                </dl>
                <dl>
                  <dt>迁移定时事件</dt><dd>{{ info.is_export_event ? '是' : '否' }}</dd>
                </dl>
                <dl>
                  <dt>迁移前备份目标数据</dt><dd>{{ info.is_export_target ? '是' : '否' }}</dd>
                </dl>
                <dl>
                  <dt>申请说明</dt><dd><span v-html="info.application_content"></span></dd>
                </dl>
                <dl v-if="info.status === 5">
                  <dt>执行结果</dt><dd><Button size="small" type="primary" @click="resultModal = true">查看结果</Button></dd>
                </dl>
                <dl v-if="info.status === 5">
                  <dt>执行状态</dt>
                  <dd>
                    <Tag v-if="info.execute_status === 2" color="green">执行成功</Tag>
                    <Tag v-else-if="info.execute_status === 3" color="red">执行失败</Tag>
                  </dd>
                </dl>
                <dl v-if="info.application_time">
                  <dt>申请时间</dt><dd>{{ moment(info.application_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <dl v-if="info.execute_time">
                  <dt>执行时间</dt><dd>{{ moment(info.execute_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <dl v-if="info.finished_time">
                  <dt>执行完成时间</dt><dd>{{ moment(info.finished_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <dl>
                  <dt>状态</dt>
                  <dd>
                    <Tag v-if="info.status_verbose === '已迁移'" color="green">{{ info.status_verbose }}</Tag>
                    <Tag v-else-if="info.status_verbose === '迁移中'" color="orange"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" style="margin-right: 5px"></Icon>{{ info.status_verbose }}</Tag>
                    <Tag v-else-if="info.status_verbose === '驳回'" color="red">{{ info.status_verbose }}</Tag>
                    <Tag v-else color="blue">{{ info.status_verbose }}</Tag>
                  </dd>
                </dl>
                <dl v-if="info.can_execute">
                  <dt>操作</dt>
                  <dd>
                    <Button type="primary" size="small" @click="execute" style="margin-right: 8px" :loading="executeSubmitting">开始迁移</Button>
                    <Button type="error" size="small" @click="refuseModal = true" :loading="executeSubmitting">驳回</Button>
                  </dd>
                </dl>
              </div>
              <Row className="margin-top-10">
                <Row class="title">
                  <h4>审批</h4>
                </Row>
                <Approves :approves="info.approves" approveType="db_data_migrate" :reFresh="this.handleReFresh" :status="info.status"/>
              </Row>
            </Col>
            <Col span="24" :md="{ span: 6, offset: 1 }">
              <div>
                <div class="title" >
                  <h4>日志信息</h4>
                </div>
                <FlowLogs :logs = "info.logs" />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import { detailDbDataMigrateFlow, refuseDbDataMigrateFlow,
  executeDbDataMigrateFlow } from '@/api/workflow/db_data_migrate_flow'
import FlowLogs from '../components/Logs'
import Approves from '../components/Approves'

export default {
  components: {
    FlowLogs,
    Approves
  },
  data () {
    return {
      moment: moment,
      info: {},
      infoError: false,
      resultModal: false,
      sourceTableModal: false,
      executeSubmitting: false,
      timer: null,
      // 驳回
      refuseModal: false,
      refuseSubmitting: false,
      refuseContent: ''
    }
  },
  created: function () {
    this.init()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    },
    'info.status_verbose' () {
      if (this.info.status_verbose === '迁移中') {
        this.setTimer()
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this.getData()
    },
    // 获取工作流信息
    getData () {
      detailDbDataMigrateFlow(this.$route.params.id).then(res => {
        this.info = res.data
        this.infoError = false
      }).catch(res => {
        console.log(res.response)
        this.infoError = true
      })
    },
    // 处理刷新操作
    handleReFresh () {
      this.init()
    },
    // 执行
    execute () {
      this.executeSubmitting = true
      executeDbDataMigrateFlow(this.$route.params.id).then(res => {
        this.getData()
        this.$Notice.success({
          title: '操作成功！'
        })
        this.executeSubmitting = false
      }).catch(res => {
        this.executeSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    // 驳回
    refuse () {
      this.refuseSubmitting = true
      refuseDbDataMigrateFlow(this.$route.params.id, this.refuseContent).then(res => {
        this.getData()
        this.$Notice.success({
          title: '操作成功！'
        })
        this.refuseSubmitting = false
        this.refuseModal = false
      }).catch(res => {
        this.refuseSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    // 自动刷新
    setTimer () {
      clearInterval(this.timer)
      this.timer = null
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getData()
        }, 5000)
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .db-data-migrate-result {
    padding: 0;
    overflow-y: auto;
    max-height: 600px;
    padding-bottom: 5px;
  }
  .db-data-migrate-result::-webkit-scrollbar {
    width: 5px;
  }
  .db-data-migrate-result::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .db-data-migrate-result::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
